// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"e7cc71ae","332":"07a1b25b","336":"7981bda5"}[chunkId] + ".chunk.js";
};